/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-09-19 20:38:21
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react'
import './index.css'
import { BsyUtils } from '../../utils/Utils';


import BsyUserGroup from '../BsyUserGroup';


export default class BsySelectUserGroup extends BsyUserGroup {


  static defaultProps = {
    baseCls: "bsy-select-user",
    width: 720,
    height: 80,
    value: [],
    type: 'usergroup',
  }

  constructor(props) {
    super(props);

    this.element = React.createRef();
  }

  renderBody = () => {
    const { value, islinkQuery, ftoken, msg, appId, is_dock_form } = this.state;
    let hasValue = '';
    return <>
      <ul className="select-list" >
        {

          !BsyUtils.isObjectEmpty(value) ? value.map(v => {

            let item = {};
            let bg = {};
            if (v) {
              if (window.userSelectMap && window.userSelectMap[v]) {
                hasValue = true;
                item = window.userSelectMap[v]
                if (item && (item.name || item.nickname))
                  bg = BsyUtils.formatUserThumb(item.name || item.nickname);
              }
            }

            return <li className="select-item" id={v}
            >
              {
                item.avatarurl ?
                  <img className="user-center" alt="" src={item.avatarurl}></img> :
                  BsyUtils.isObjectEmpty(bg) ? '' : <span className={'table-user-portrait-name color-' + bg.color} ><span>{bg.name[0]}</span></span>
              }
              <span>{BsyUtils._toDeptUser(item)}</span>
            </li>
          }) : <div className="select-empty"> </div>
        }


      </ul>
      {
        this.renderBtn('icon-widget-usergroup', hasValue)
      }
    </>

  }

  render() {
    const { cssName, css } = this.options
    if (!this.isEnabled()) {
      return this.renderDisablePane()
    }
    return (
      <div className={cssName} style={css}
        ref={this.element}
        onClick={this.onClick}
      >
        {
          this.renderBody()
        }
      </div>
    )
  }
}
